class GroupChatInvite {
  id: Number;
  roomId: Number;
  roomName: string;
  subject: string;
  coverUrl: string;
  roomJid: string;
  isPrivate: boolean;
  isExpired: boolean;
  expiredAt: number;
  isEnded: boolean;
  refObjId: Number;
  refObjType: string;
  isActive: boolean;
  ts: number;
  userDelete: number;
  isMatching: boolean;

  constructor() {
    this.id = -1;
    this.roomId = -1;
    this.roomName = '';
    this.subject = '';
    this.coverUrl = '';
    this.roomJid = '';
    this.isPrivate = false;
    this.isExpired = false;
    this.expiredAt = 0;
    this.isEnded = false;
    this.refObjId = -1;
    this.refObjType = '';
    this.isActive = false;
    this.ts = 0;
    this.userDelete = 0;
    this.isMatching = true;
  }
  static mappingObject(_o: any): IGroupChatInvite {
    const res = new GroupChatInvite();
    if (_o) {
      res.id = _o.id;
      res.roomId = _o.roomId;
      res.roomName = _o.roomName;
      res.subject = _o.subject;
      res.coverUrl = _o.coverUrl;
      res.roomJid = _o.roomJid;
      res.isPrivate = _o.isPrivate;
      res.isExpired = _o.isExpired;
      res.expiredAt = _o.expiredAt;
      res.isEnded = _o.isEnded;
      res.refObjId = _o.refObjId;
      res.refObjType = _o.refObjType;
      res.isActive = _o.isActive;
      res.ts = _o.ts;
      res.userDelete = _o.userDelete;
      res.isMatching = _o.isMatching;
    }
    return res as IGroupChatInvite;
  }

  static mappingObjects(_data = []): IGroupChatInvite[] {
    return _data.map(i => GroupChatInvite.mappingObject(i));
  }
}

export default GroupChatInvite;
